import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Section } from "@/components/Section";
import { SEO } from "@/components/SEO";
import { blogSeed } from "@/config/site";
import { ArrowRight, Clock } from "lucide-react";

export default function Blog() {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/blog/posts").then((r) => setPosts(r.data)).catch(() => {}).finally(() => setLoading(false));
    }, []);

    const publishedSlugs = new Set(posts.map((p) => p.slug));
    const upcoming = blogSeed.filter((b) => !publishedSlugs.has(b.slug));

    return (
        <>
            <SEO title="Wiedza – Szymkas Agency" description="Artykuły o stronach internetowych, brandingu, social mediach, marketingu i AI w biznesie." />
            <section className="bg-[#06111F] text-white pt-32 pb-16 md:pt-40 md:pb-20 relative overflow-hidden">
                <div className="absolute inset-0 bg-grid-faint opacity-50" />
                <div className="relative max-w-4xl mx-auto px-5 md:px-8 text-center">
                    <div className="text-xs font-semibold tracking-widest uppercase text-[#14B8A6] mb-3">Wiedza</div>
                    <h1 className="font-display font-extrabold text-[38px] md:text-[58px] lg:text-[64px] leading-[1.05] tracking-tight">
                        Praktyczna wiedza o marketingu<br /><span className="text-[#14B8A6]">i rozwoju firmy w sieci</span>
                    </h1>
                </div>
            </section>
            <Section variant="light">
                {loading ? (
                    <div className="text-center text-[#0B1220]/50">Wczytywanie…</div>
                ) : (
                    <>
                        {posts.length > 0 && (
                            <>
                                <h2 className="font-display font-bold text-2xl md:text-3xl mb-6 text-[#0B1220]">Najnowsze artykuły</h2>
                                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 mb-16">
                                    {posts.map((p) => (
                                        <Link key={p.slug} to={`/blog/${p.slug}`} className="group rounded-[20px] bg-white border border-[#E5E7EB] p-6 hover:-translate-y-1 hover:shadow-[0_24px_50px_-20px_rgba(20,184,166,0.25)] hover:border-[#14B8A6]/40 transition-all" data-testid={`blog-post-${p.slug}`}>
                                            <div className="text-xs font-semibold tracking-wider uppercase text-[#14B8A6] mb-2">{p.category}</div>
                                            <h3 className="font-display font-semibold text-lg md:text-xl text-[#0B1220] mb-3 line-clamp-2">{p.title}</h3>
                                            <p className="text-sm text-[#0B1220]/65 leading-relaxed line-clamp-3">{p.excerpt}</p>
                                            <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-[#14B8A6] group-hover:gap-2 transition-all">Czytaj <ArrowRight className="w-4 h-4" /></span>
                                        </Link>
                                    ))}
                                </div>
                            </>
                        )}
                        {upcoming.length > 0 && (
                            <>
                                <h2 className="font-display font-bold text-2xl md:text-3xl mb-6 text-[#0B1220]">Już wkrótce</h2>
                                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
                                    {upcoming.map((b) => (
                                        <div key={b.slug} className="rounded-[20px] border border-dashed border-[#E5E7EB] bg-[#F6F8FA] p-6" data-testid={`blog-upcoming-${b.slug}`}>
                                            <div className="text-xs font-semibold tracking-wider uppercase text-[#14B8A6] mb-2">{b.category}</div>
                                            <h3 className="font-display font-semibold text-lg text-[#0B1220] mb-3">{b.title}</h3>
                                            <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-[#0B1220]/40">
                                                <Clock className="w-3.5 h-3.5" /> Wkrótce
                                            </span>
                                        </div>
                                    ))}
                                </div>
                            </>
                        )}
                    </>
                )}
            </Section>
        </>
    );
}
